<mat-icon class="close" (click)="close()">close</mat-icon>
<div class="container-fluid pt-2">
    <div class="Tabletitle">
        <span class="mt-5" style="font-size: 20px"> Selected folder to upload - {{selectedFolderPath}} </span>
    </div>
    <div class="dropzone p-1" appDnd>
        <input type="file" #fileDropRef id="fileDropRef" webkitdirectory multiple (change)="handleFileInput($event)"
            style="cursor: pointer;" /><br>
        <div>
            <mat-icon style="font-size: 40px; " class="mt-5">cloud_upload</mat-icon>
            <h3>Drag and drop folder here</h3>                       
        </div>
    </div>
    <div class="browseFiles p-1">
        <h3>or</h3>
    </div>
    <div class="browseFiles p-1">
        <input type="file" #fileInput (change)="handleFileInput($event)" [style.visibility]="'hidden'" multiple/><br>
        <button (click)="openFileBrowser()" class="upload-label">Browse for files</button>
    </div>
    <div class="dropbottom p-1"></div>
    <form #initiateForm="ngForm">
        <div class="row" *ngIf="isDocumentUploaded">
            <!-- <div class="col-6">
                <div class="input-group-sm mb-1 input-group">
                    <div class="input-group-prepend"><span class="input-group-text form-label-50"><strong>Enter Water Right ID</strong></span>
                    </div>
                    <textarea class="textarea-waterrightid" matInput [(ngModel)]="waterRightId" (keydown)="validateID('WR_ID', $event)" name="water-right-id" placeholder="Type Multiple WRID Separated by comma"></textarea>
                </div>
            </div>
            <div *ngIf="isErrorOnMetadata" class="col-6" style="color: red; padding-top: 0.2rem">
                {{metadataErrorMessage}}
            </div> -->
            <app-dynamic-form (formValue)="onFormValue($event)" (isValidData)="validationCheck($event)"></app-dynamic-form>
            
            <!-- <div class="col-4">
                <div class="input-group-sm mb-1 input-group">
                    <div class="input-group-prepend"><span class="input-group-text form-label-50">Water Right ID</span>
                    </div>
                    <mat-select [(ngModel)]="selectedUser" name="compliance" class="form-control" required>
                        <mat-option>
                            <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                                [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let owner of allUsers | stringFilter:searchCtrl:'name'" [value]="owner">
                            <mat-icon>person</mat-icon>{{owner}}
                        </mat-option>
                        <mat-option *ngFor="let owner of allGroups | stringFilter:searchCtrl:'name'" [value]="owner">
                            <mat-icon>groups</mat-icon>{{owner}}
                        </mat-option>
                        <mat-select-trigger>
                            {{selectedUser}}
                        </mat-select-trigger>
                    </mat-select>
                </div>
            </div> -->
        </div>


        <div *ngIf="isDocumentUploaded">
            
            <table mat-table [dataSource]="docsList" matSort aria-describedby="capture-table">
                <!-- Checkbox Column -->          
                <ng-container matColumnDef="File Name">
                    <th id="file-name" mat-header-cell *matHeaderCellDef>File Name
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.fileName}}

                        <div class="progress">
                            <div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar"
                                attr.aria-valuenow="{{ element.value }}" aria-valuemin="0" aria-valuemax="100"
                                [ngStyle]="{ width: element.value + '%' }">
                                {{ element.value }}%
                            </div>
                        </div>
                        <!-- <div class="new" *ngIf="element.value === 100">
            File Upload Completed!
          </div> -->


                    </td>
                </ng-container>
                <ng-container matColumnDef="Size">
                    <th id="size" mat-header-cell *matHeaderCellDef>Size
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.size|filesize}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="Type">
                    <th id="type" mat-header-cell *matHeaderCellDef>Type
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.dataType}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="Path">
                    <th id="path" mat-header-cell *matHeaderCellDef>Path
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.path}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th id="actions" mat-header-cell *matHeaderCellDef mat-sort-header></th>
                    <td mat-cell *matCellDef="let element">
                        <div *ngIf="!fileLoading">
                            <button mat-icon-button title="Remove File" (click)="removeFile($event, element)"
                                style="font-size: 15px;">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="documentCols"></tr>
                <tr mat-row *matRowDef="let row; columns: documentCols;" class="element-row">
                </tr>
                <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr> -->

            </table>
        </div>


        <div *ngIf="isDocumentUploaded">
            <button mat-raised-button (click)="onClose()" class="backButton m-2" style="float: right">Close</button>
        </div>
        <div *ngIf="isDocumentUploaded">
            <button mat-raised-button (click)="uploadCaptureDocument()" class="actionButton m-2" style="float: right"
                [disabled]="!isDocumentUploaded">Upload</button>
        </div>
    </form>
     
</div>